import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import DateInput from "components/Input/DateInput.js";
import IntInput from "components/Input/IntInput.js";
import TextInput from "components/Input/TextInput.js";
import {
  CustomSelect,
  FloatInput,
} from "components/Input/Index.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Button from "@mui/material/Button";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
import ImageList from "@mui/material/ImageList";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";

import { getAlertRule } from "services/ConfigServices";
import styled from "styled-components";
import AdvancedSearch from "./AdvancedSearch";
import RulesTab from "./CustomAlert/RulesTab";
import { criticityData, alerttypeData, alerttypeDataNoPersonalized, alertpredifinedrulesData, getObjectFromId } from "variables/lists/alerts";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "10%",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "10%",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const emailPattern = new RegExp(
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i
);

function EditAlertRuleDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const { closeModal, refetch, setLoading, setNotification } = props;
  const handleSubmit = (event) => {
    updateRule(event);
    setLoading(true);
    closeModal();
  };

  useEffect(() => {
    if((type===1 && predifinedrule==='') || !name || !groups || groups.length === 0 || groups[0] === '0')
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  const updateRule = async (event) => {
    axios
      .put(
        getAlertRule(props.id),
        {
          name,
          predifinedrule,
          type,
          groups,
          description,
          active,
          criticity,
          diffusion: { email: diffusionemail, sms: diffusionsms },
          category,
          desctext,
          rule,
          filters,
          filterType,
          granularity,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Règle modifiée");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        setLoading(false);
      });
  };

  
  const [type, setType] = React.useState(props.type);
  const [predifinedrule, setPredifinedrule] = React.useState(props.predifinedrule);
  const [name, setName] = React.useState(props.name);
  const [description, setDescription] = React.useState(props.description);
  const [active, setActive] = React.useState(props.active);
  const [criticity, setCriticity] = React.useState(props.criticity);
  const [groups, setGroups] = React.useState(props.groups);
  const [diffusionemail, setDiffusionEmail] = React.useState(props.diffusion?.email || []);
  const [diffusionsms, setDiffusionSms] = React.useState(props.diffusion?.sms || []);
  const [category, setCategory] = React.useState(props.category);
  const [desctext, setDesctext] = React.useState(props.desctext);
  const [filters, setFilters] = React.useState(props.filters);
  const [filterType, setFilterType] = useState(props.filterType || '1.0');
  const [rule, setRule] = useState(props.rule);
  const [granularity, setGranularity] = React.useState(props.granularity || '1h');
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const handleTypeChange = (event) => { setType(event.target.value); };
  const handlePredifinedruleChange = (event) => {
    let predrule = getObjectFromId(event.target.value, alertpredifinedrulesData);
    if (predrule && predrule.name && predrule.name !== '')
      setName(predrule.name);
    else
      setName("");
    if (predrule && predrule.description && predrule.description !== '')
      setDescription(predrule.description);
    else
      setDescription("");
    if (predrule && predrule.category && predrule.category !== '')
      setCategory(predrule.category);
    else
      setCategory("");
    setPredifinedrule(event.target.value);
  };
  const handleNameChange = (event) => { setName(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };
  const handleActiveChange = (event) => { setActive(!active); };
  const handleCriticityChange = (event) => { setCriticity(event.target.value); };
  const handleDiffusionEmailChange = (newValue) => {
    setDiffusionEmail(newValue);
  };
  const handleDiffusionSmsChange = (newValue) => {
    setDiffusionSms(newValue);
  };
  const handleCategoryChange = (event) => { setCategory(event.target.value); };
  const handleDesctextChange = (event) => { setDesctext(event.target.value); };

  const handleRuleChange = (val) => {
    setRule(val);
  };
  const handleFiltersChange = (val) => {
    setFilters(val);
  };

  const classes = useStyles();
  const [value, setValue] = useState("0");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value} className={classes.root}>
      <div className={classes.demo2}>
        <AppBar
          position="static"
          className={classes.demo3}
          style={{ boxShadow: "none", shadowColor: "red" }}
        >
          <StyledTabs
            value={value}
            onChange={handleChange}
            aria-label="styled tabs example"
            scrollButtons="auto"
          >
            <StyledTab label="Paramètres généraux" value="0" />
            <StyledTab label="Filtres" value="1" />

            {
              type == 0 ?
                <StyledTab label="Règles" value="2" />
                : <></>
            }
          </StyledTabs>
          <Typography className={classes.padding} />
        </AppBar>
        <Divider variant="fullWidth" />
        <TabPanel value="0" style={{ marginBottom: "-35px" }}>
          <form className={classes.root}>
            <GridContainer>
              <GridItem xs={12} sm={6} md={7} lg={7}>
                <div>
                  <CustomSelect
                    inputTitle={"Type"}
                    selectValue={type}
                    handleSelectValueChange={handleTypeChange}
                    data={memv2versionactive > 0 ? alerttypeData : alerttypeDataNoPersonalized}
                  />
                </div>
                {type == 1 ?
                  <div>
                    <CustomSelect
                      inputTitle={"Règle prédéfinie"}
                      selectValue={predifinedrule}
                      handleSelectValueChange={handlePredifinedruleChange}
                      data={alertpredifinedrulesData}
                    /></div> : <></>
                }
                <div>
                  <TextInput
                    inputTitle={"Nom"}
                    textInput={name}
                    handleTextInputChange={handleNameChange}
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={"Description"}
                    textInput={description}
                    handleTextInputChange={handleDescriptionChange}
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={"Catégorie"}
                    textInput={category}
                    handleTextInputChange={handleCategoryChange}
                  />
                </div>
                <div>
                  <CustomSelect
                    inputTitle={"Criticité"}
                    selectValue={criticity}
                    handleSelectValueChange={handleCriticityChange}
                    data={criticityData}
                  />
                </div>
                <div>
                  <AutocompleteTagsInput
                    specialWidth={"97%"}
                    inputTitle={"Diffusion par email"}
                    list={[]}
                    selected={diffusionemail}
                    handleChange={handleDiffusionEmailChange}
                  />
                </div>
                {/* <div>
                  <AutocompleteTagsInput
                    specialWidth={"97%"}
                    inputTitle={"Diffusion par sms"}
                    list={[]}
                    selected={diffusionsms}
                    handleChange={handleDiffusionSmsChange}
                  />
                </div> */}
                <div>
                  <CustomSwitch
                    inputTitle={"Règle active"}
                    checkedState={active}
                    handleSwitchChange={handleActiveChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={12} sm={6} md={5} lg={5}>
                <div
                  className={classes.treeVisible}
                >
                  <TreeLabel>Choix du périmètre</TreeLabel>
                  <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                    <EmbeddedEntitesTree
                      selectedIds={setGroups}
                      userSelectedIds={groups}
                      multiSelect={true}
                    />
                  </ImageList>
                </div>
              </GridItem>
            </GridContainer>
          </form>
        </TabPanel>
        <TabPanel value="1">
          <AdvancedSearch
            filters={filters}
            handleFiltersChange={handleFiltersChange}
            type={filterType}
            ruletype={type}
            setType={setFilterType}
          ></AdvancedSearch>
        </TabPanel>

        {type == 0 ?
          <TabPanel value="2">
            <RulesTab
              rule={rule}
              handleRuleChange={handleRuleChange}
              granularity={granularity}
              setGranularity={setGranularity}
            ></RulesTab>
          </TabPanel>
          : <></>
        }

      </div>
      <Button
        disabled={buttonDisabled}
        className={
          buttonDisabled
            ? classes.submitButtonDisabled
            : classes.submitButton
        }
        onClick={() => {
          handleSubmit();
        }}
      >
        Modifier
      </Button>
    </TabContext>
  );
}

export default EditAlertRuleDialog;
